module.exports = __webpack_public_path__ + "static/CAlogo-footer-ccfde8634d538c2aebb13751304f3ca5.svg";